import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import swal from 'sweetalert';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas, faPenToSquare, faRotate, faTrash, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import { applyPlugin } from 'jspdf-autotable';
import { saveAs } from 'file-saver';
applyPlugin(jsPDF);
const today = new Date().toISOString().split('T')[0];

function Users() {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState(false);
  const [userId, setUserId] = useState("");
  const currentUser = useSelector((state) => state.data);
  const [data, setData] = useState(false);
  const [data1, setData1] = useState(false);
  const [uploadData, setUploadData] = useState(false);
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);
  const [editIndex, setEditIndex] = useState(0);
  const [viewData, setViewData] = useState(false);
  const [editData, setEditData] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );
  const handleClose = () => {
    setViewData(false);
    setEditData(false);
  }
  const handleSearch = async (e) => {
    e.preventDefault();
    const { type, start_date, end_date } = e.target;
    let rechargeData = {
      userId,
      type: type.value,
      start_date: start_date.value,
      end_date: end_date.value,
    };
    getData(rechargeData);
  };

  const fetchData = async (event) => {
    let rechargeData = {
      first: event.first,
      rows: event.rows,
      userId: pageData.userId,
      type: pageData.type,
      start_date: pageData.start_date,
      end_date: pageData.end_date,
    };
    getData(rechargeData);
  };

  const getData = async (requestData) => {
    try {
      setLoading(true);
      const response = await axios.post("/history/userHistory", requestData);
      const { status, data, body, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setData1(response.data);
        setPageData({ ...body, first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const viewUser = (index) => {
    setViewIndex(index);
    setViewData(true);
  };

  const editUser = (index) => {
    setEditIndex(index);
    setEditData(true);
  };

  const resetUser = async (userId) => {
    const response = await axios.post("/action/resetUser", { userId });
    const { status, message } = response.data;
    if (status) {
      toast(message);
    }
  };

  const deleteUser = async (userId) => {
    const willApprove = await swal({
      title: "Are you sure?",
      text: "Are you sure that you want to delete this user?",
      icon: "warning",
      dangerMode: true,
    });
    if (willApprove) {
      try {
        const response = await axios.post("/action/deleteUser", { userId });
        const { status, message } = response.data;
        if (status) {
          toast(message);
        }
      }
      catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const changeData = async (e) => {
    let name = e.target.name;
    let value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setData1({ ...data1, data: { ...data1.data, [editIndex]: { ...data1.data[editIndex], [name]: value } } });
  };

  function addSpaceBetweenCases(str) {
    return capitalizeWords(str.replace(/([a-z])([A-Z])/g, '$1 $2')).replaceAll("_", " ");
  }

  function capitalizeWords(string) {
    return string.split(' ').map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ')
  }

  const ChangeStatus = async (options, e) => {
    try {
      options.editorCallback(e.target.value);
      const { name, value } = e.target;
      const response = await axios.post("/action/changeUserData", { [name]: value, userId: options.rowData._id });
      const { status, message, data } = response.data;
      if (status) {
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  const onCellEditComplete = (e) => {
    let { rowData, newValue, field, originalEvent: event } = e;
    rowData[field] = newValue;
  };

  const cellEditor1 = (options) => {
    return (
      <select name="user_type" value={options.value} onChange={(e) => ChangeStatus(options, e)} onKeyDown={(e) => e.stopPropagation()}>
        <option value="user">User</option>
        <option value="dealer">Dealer</option>
      </select>
    );
  };

  const cellEditor2 = (options) => {
    return (
      <select name="status" value={options.value} onChange={(e) => ChangeStatus(options, e)} onKeyDown={(e) => e.stopPropagation()}>
        <option value="0">InActive</option>
        <option value="1">Active</option>
      </select>
    );
  };

  const updateSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.type === 'checkbox') {
          jsonData[item.name] = item.checked;
        }
        else {
          jsonData[item.name] = item.value;
        }
      }
    });
    try {
      const response = await axios.post('/action/updateUser', { ...jsonData, userId: data1 && data1.data[editIndex]._id });
      const { status, message } = response.data;
      if (status) {
        handleClose();
      }
      toast(message);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions(false);
      setUserId("");
      return;
    }
    axios.get(`/users/search?q=${encodeURIComponent(query)}`).then((res) => {
      setSuggestions(res.data.users); // Adjust to your API response
      setLoading(false);
    }).catch(() => {
      setSuggestions(false);
      setLoading(false);
    });
  }, [query]);

  const exportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data.data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    const file = new Blob([excelBuffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });

    saveAs(file, 'data_export.xlsx');
  };

  const exportPDF = () => {
    const doc = new jsPDF();
    const columns = Object.keys(data.data[0] || {}).map(key => ({
      header: key,
      dataKey: key
    }));
    doc.autoTable({
      columns,
      body: data.data
    });
    doc.save('data_export.pdf');
  };

  const uploadImage = async (e) => {
    const formData = new FormData();
    formData.append('id', data?.data[viewIndex]?._id);
    formData.append('field', e.target.name);
    formData.append('image', e.target.files[0]);
    formData.append('by', "user");
    try {
      const response = await axios.post("/uploadFiles", formData);
      const { image, message } = response.data;
      if (image) {
        setUploadData({ ...uploadData, [e.target.name]: image });
        toast(message);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Users Search</h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div className="row">
                  {
                    currentUser && currentUser.user_type == "admin" && (
                      <div class="col-lg-3 col-md-3">
                        <label for="user_id">Users</label>
                        {/* <select class="form-control" name="user_id">
                          <option value="">--Select--</option>
                          {
                            users && users.map(user => (
                              <option value={user._id}>{user.name}</option>
                            ))
                          }
                        </select> */}
                        <input
                          type="text"
                          class="form-control"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          placeholder="Type to search..."
                        />

                        {suggestions && suggestions.length > 0 && (
                          <ul
                            style={{
                              border: "1px solid #ccc",
                              marginTop: 0,
                              paddingLeft: 0,
                              listStyleType: "none",
                              maxHeight: 150,
                              overflowY: "auto",
                              cursor: "pointer",
                            }}
                          >
                            {suggestions.map((item, idx) => (
                              <li
                                key={idx}
                                style={{ padding: "8px", borderBottom: "1px solid #eee" }}
                                onClick={() => {
                                  setQuery(item.name + "(" + item.mobile + ")"); // Adjust as per your data structure
                                  setUserId(item._id);
                                  setSuggestions(false);
                                }}
                              >
                                {item.name + "(" + item.mobile + ")"}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    )
                  }
                  <div class="col-lg-3 col-md-3">
                    <label>User Type</label>
                    <select class="form-control" name="type">
                      <option value="">All</option>
                      <option value="user">User</option>
                      <option value="dealer">Dealer</option>
                      <option value="admin">Admin</option>
                    </select>
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>From Date</label>
                    <input class="form-control" type="date" name="start_date" max={today} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <label>To Date</label>
                    <input class="form-control" type="date" name="end_date" max={today} />
                  </div>
                  <div class="col-lg-3 col-md-3">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                (data && data.data && (Object.entries(data.data).length > 0)) && (
                  <>
                    <h4 class="card-title">
                      Users History
                    </h4>
                    <div className="row">
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Records</strong></label>
                        <div>{data.records.totalRecords}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Admins</strong></label>
                        <div>{data.records.totalAdmins}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Dealers</strong></label>
                        <div>{data.records.totalDealers}</div>
                      </div>
                      <div class="rechargeOp col-lg-2 col-md-2">
                        <label><strong>Total Users</strong></label>
                        <div>{data.records.totalUsers}</div>
                      </div>
                    </div>
                    {/* <div className="p-mb-2" style={{ marginBottom: '1rem' }}>
                      <button
                        className="btn btn-primary"
                        onClick={exportExcel}
                      >
                        Excel
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={exportPDF}
                      >
                        PDF
                      </button>
                    </div> */}
                    <DataTable
                      value={data.data}
                      size="small"
                      editMode="cell"
                      globalFilter={globalFilter}
                      header={header}
                      className="custom-table" // Add custom class here
                      loading={loading}
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="user_id"
                        header="User(Mobile)"
                        sortable
                        body={(rowData) => <span data-label="User">{rowData?.name}<br />({rowData?.mobile})</span>}
                      />
                      <Column
                        field="email"
                        header="Email"
                        sortable
                        body={(rowData) => <span data-label="Email">{rowData?.email}</span>}
                      />
                      <Column
                        field="user_type"
                        header="User Type"
                        sortable
                        body={(rowData) => <span data-label="User Type">{capitalizeWords(rowData?.user_type)}</span>}
                        editor={(options) => cellEditor1(options)}
                        onCellEditComplete={onCellEditComplete}
                      />
                      <Column
                        field="wallet_balance"
                        header="Wallet Balance"
                        sortable
                        body={(rowData) => <span data-label="Wallet Balance">{(rowData.wallet_balance).toFixed(2)}</span>}
                      />
                      <Column
                        field="remit_balance"
                        header="Remit Balance"
                        sortable
                        body={(rowData) => <span data-label="Remit Balance">{(rowData.remit_balance).toFixed(2)}</span>}
                      />
                      <Column
                        field="status"
                        header="Status"
                        sortable
                        body={(rowData) => <span data-label="Status">{rowData.status == "1" ? "Active" : "InActive"}</span>}
                        editor={(options) => cellEditor2(options)}
                        onCellEditComplete={onCellEditComplete}
                      />
                      <Column
                        field="action"
                        header="Action"
                        sortable
                        body={
                          (rowData, { rowIndex }) => (
                            <span data-label="Action">
                              <Link onClick={(e) => viewUser(rowIndex)}><FontAwesomeIcon icon={fas.faEye} className="successIcon" title="View" /></Link>
                              <Link onClick={(e) => editUser(rowIndex)}><FontAwesomeIcon icon={faPenToSquare} className="successIcon" title="Edit" /></Link>
                              <Link onClick={(e) => resetUser(rowData._id)}><FontAwesomeIcon icon={faRotate} className="successIcon" title="Reset" /></Link>
                              <Link onClick={(e) => deleteUser(rowData._id)}><FontAwesomeIcon icon={faTrash} className="successIcon" title="Delete" /></Link>
                              {/* <button className="btn btn-primary" onClick={(e) => viewUser(rowIndex)}>View</button>
                              <button className="btn btn-primary" onClick={(e) => editUser(rowIndex)}>Edit</button>
                              <button className="btn btn-primary" onClick={(e) => resetUser(rowData._id)}>Reset</button> */}
                            </span>
                          )
                        }
                      />
                    </DataTable>
                    <div className="card">
                      <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      {/* Modal component */}
      <Modal show={viewData} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>User Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs
            defaultActiveKey="user_info"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="user_info" title="User info">
              {
                (data && data.data && (Object.entries(data.data).length > 0)) && (
                  <>
                    <ul className="showData">
                      {Object.entries(data.data[viewIndex]).map(([key, value]) => (
                        (!["", false, true, null].includes(value) && !["_id", "password", "indiaAddress", "nepalAddress", "kyc_id", "profile_picture", "aadhar_card_back", "aadhar_card_front", "pan_card_front", "__v", "created_at", "updated_at"].includes(key) && (value.toString()).indexOf("_") == "-1") && (
                          <li key={key}>
                            <strong>{addSpaceBetweenCases(key)}:</strong>
                            <div>{value}</div>
                          </li>
                        )
                      ))}
                    </ul>
                  </>
                )
              }
            </Tab>
            <Tab eventKey="documents" title="Documents">
              {
                (data && data.data && (Object.entries(data.data).length > 0)) && (
                  <>
                    <ul className="showData">
                      {Object.entries(data.data[viewIndex]).map(([key, value]) => (
                        (["profile_picture", "aadhar_card_back", "aadhar_card_front", "pan_card_front"].includes(key)) && (
                          <li key={key}>
                            <strong>{addSpaceBetweenCases(key)}:</strong>
                            <div className="settingImage"><img src={uploadData[key] ? process.env.REACT_APP_BACKEND_URL + "/uploads/idproof/" + uploadData[key] : value} /></div>
                            <div><input type="file" className="form-control" name={key} onChange={uploadImage} /></div>
                          </li>
                        )
                      ))}
                    </ul>
                  </>
                )
              }
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>
      <Modal show={editData} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Form onSubmit={updateSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Update User Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-4 col-md-4">
                    <label>Name</label>
                    <input className="form-control" type="text" name="name" value={data1?.data?.[editIndex]?.name} onChange={changeData} />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Email</label>
                    <input className="form-control" type="email" name="email" value={data1?.data?.[editIndex]?.email} onChange={changeData} />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Mobile</label>
                    <input className="form-control" type="number" name="mobile" value={data1?.data?.[editIndex]?.mobile} onChange={changeData} />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Prabhu CSP Code</label>
                    <input className="form-control" type="text" name="csp_code" value={data1?.data?.[editIndex]?.csp_code} onChange={changeData} />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>IME CSP Code</label>
                    <input className="form-control" type="text" name="ime_csp_code" value={data1?.data?.[editIndex]?.ime_csp_code} onChange={changeData} />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>IME CSP Code(KYC)</label>
                    <input className="form-control" type="text" name="ime_csp_code_kyc" value={data1?.data?.[editIndex]?.ime_csp_code_kyc} onChange={changeData} />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>IME Commission</label>
                    <input className="form-control" type="number" name="ime_commission" value={data1?.data?.[editIndex]?.ime_commission} onChange={changeData} />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Prabhu Commission on ₹1 - 5150</label>
                    <input className="form-control" type="number" name="remit_commission" value={data1?.data?.[editIndex]?.remit_commission} onChange={changeData} />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Prabhu Commission on 5151 - ₹50000</label>
                    <input className="form-control" type="number" name="remit_commission_2" value={data1?.data?.[editIndex]?.remit_commission_2} onChange={changeData} />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Prabhu Commission Bank on ₹1 - 5150</label>
                    <input className="form-control" type="number" name="remit_commission_bank" value={data1?.data?.[editIndex]?.remit_commission_bank} onChange={changeData} />
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Prabhu Commission Bank on 5151 - ₹50000</label>
                    <input className="form-control" type="number" name="remit_commission_2_bank" value={data1?.data?.[editIndex]?.remit_commission_2_bank} onChange={changeData} />
                  </div>
                </div>
                <p class="card-description">
                  Permissions
                </p>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="overide_permissions" name="overide_permissions" checked={data1?.data?.[editIndex]?.overide_permissions} onChange={changeData} />
                      <label class="form-check-label" for="overide_permissions">Override Permissions</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="prabhu_money_transfer" name="prabhu_money_transfer" checked={data1?.data?.[editIndex]?.prabhu_money_transfer} onChange={changeData} />
                      <label class="form-check-label" for="prabhu_money_transfer">Prabhu Money Transfer</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="prabhu_csp_onboarding" name="prabhu_csp_onboarding" checked={data1?.data?.[editIndex]?.prabhu_csp_onboarding} onChange={changeData} />
                      <label class="form-check-label" for="prabhu_csp_onboarding">Prabhu CSP Onboarding</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="ime_money_transfer" name="ime_money_transfer" checked={data1?.data?.[editIndex]?.ime_money_transfer} onChange={changeData} />
                      <label class="form-check-label" for="ime_money_transfer">IME Money Transfer</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="ime_remittance_searching" name="ime_remittance_searching" checked={data1?.data?.[editIndex]?.ime_remittance_searching} onChange={changeData} />
                      <label class="form-check-label" for="ime_remittance_searching">IME Remittance Searching</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="ime_remittance_create_customer" name="ime_remittance_create_customer" checked={data1?.data?.[editIndex]?.ime_remittance_create_customer} onChange={changeData} />
                      <label class="form-check-label" for="ime_remittance_create_customer">IME Remittance Create Customer</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch" id="ime_csp_onboarding" name="ime_csp_onboarding" checked={data1?.data?.[editIndex]?.ime_csp_onboarding} onChange={changeData} />
                      <label class="form-check-label" for="ime_csp_onboarding">IME CSP Onboarding</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              Update
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
}

export default Users;
